import { render, staticRenderFns } from "./payment-method-view.vue?vue&type=template&id=5b79ca02&scoped=true&"
import script from "./payment-method-view.vue?vue&type=script&lang=js&"
export * from "./payment-method-view.vue?vue&type=script&lang=js&"
import style0 from "./payment-method-view.vue?vue&type=style&index=0&id=5b79ca02&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b79ca02",
  null
  
)

export default component.exports